import React, { useEffect, useState, useRef } from 'react';
import {
  Card,
  CardBody,
  Col,
  Table,
  Button,
  Input,
  Spinner,
  // Form,
  FormGroup,
  // Select,
  Row
} from 'reactstrap';

import {
  getThemeList,
  getSiteList,
  getScrapperImportList,
  postScrapperImportTrigger
} from '../../../util/api';
// import { toast } from 'react-toastify';
import { DateTime } from "luxon";

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback if it changes
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    if (delay === null) return; // Skip if delay is null
    const tick = () => savedCallback.current();
    const id = setInterval(tick, delay);
    return () => clearInterval(id); // Cleanup on unmount
  }, [delay]);
}

export function useTimeout(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback if it changes
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    if (delay === null) return; // Skip if delay is null
    const tick = () => savedCallback.current();
    const id = setTimeout(tick, delay);
    return () => clearTimeout(id); // Cleanup on unmount
  }, [delay]);
}


const ENABLED_DATABASES =  ['autoweb_scraper', 'starkwood_scraper', 'Spidernet'];
const PageContent = () => {
  const [ scrapperImportList, setScrapperImportList ] = useState([]);
  const [ themes, setThemes ] = useState([]);
  const [ themeSelected, setThemeSelected ] = useState(null);
  const [ sites, setSites ] = useState({ data: [] });
  const [ isTriggeringEnabled, setIsTriggeringEnabled ] = useState(true);
  const [ delayTrigger, setDelayTrigger ] = useState(null);
  const [ delayCount, setDelayCount ] = useState(null);
  // const countTimeout = useRef(null);

  const resetCodesList = async () => {
    try{
      const response = await getThemeList();
      if( response.status !== 'success' ) return

      // Store themes
      setThemes( response.data );
      // Select first if none selected
      let themeSelectedLocal = themeSelected;
      if(themeSelected == null ){
        themeSelectedLocal = response.data[0].name;
        setThemeSelected( response.data[0].name );
      }

      let siteResponse = await getSiteList( response.data[0].name );
      if( siteResponse.status === 'success' )
        setSites( siteResponse );


      // setDelayCount(200)
      // if( countTimeout.current ){
      //   clearTimeout( countTimeout.current );
      //   countTimeout.current = null;
      // }

      // // Load with count
      // countTimeout.current = setTimeout(async () => {
      //   const siteResponse = await getSiteList( response.data[0].name, {count:true} );

      //   if(themeSelectedLocal !== themeSelected ) return; // Stale response check
      //   if( siteResponse.status === 'success' )
      //     setSites( siteResponse.data );
      // }, 200)
      
      siteResponse = await getSiteList( response.data[0].name, {count:true} );
      if( siteResponse.status === 'success' )
        setSites( siteResponse );

      return themeSelectedLocal
    }catch(e){
      console.log("Error in reseting codes list ", e )
    }

  };

  // ---------------------
  // Hooks
  // ---------------------

  useEffect(() => {
    ( async () => {

      const themeSelectedLocal = await resetCodesList();

      const response = await getScrapperImportList()
      if( response.status !== 'success' ) return
      const scrapperImportListLocal = response.data
      setScrapperImportList( scrapperImportListLocal );
      
      
      console.log("Scrapper Import List ", scrapperImportListLocal, themeSelectedLocal )

      // Set Triggering enabled
      const scrapperImport = scrapperImportListLocal.find( (item) => item.database === themeSelectedLocal )
      let isTriggeringEnabledLocal = false;
      // if(scrapperImport != null)
      //   isTriggeringEnabledLocal = ENABLED_DATABASES.includes(scrapperImport.database) && scrapperImport.status !== 'ongoing';
      if(scrapperImport != null)
        isTriggeringEnabledLocal = scrapperImport.status !== 'ongoing';      
      console.log("Is Triggering Enabled ", scrapperImport, isTriggeringEnabledLocal )
      setIsTriggeringEnabled( isTriggeringEnabledLocal );

    })();

  }, []);

  useInterval( async () => {
    const response = await getScrapperImportList()
    if( response.status !== 'success' ) return
    setScrapperImportList( response.data );
    

    if( response.data.some( (item) => item.status === 'ongoing' ) ){
      // Do nothing
    }else{
      setDelayTrigger(null)
    }
  }, delayTrigger)

  useTimeout( async () => {
    const siteResponse = await getSiteList( themeSelected, {count:true} );
    console.log("Theme selected in timeout ", themeSelected, delayCount )
    if( siteResponse.status === 'success' )
      setSites( siteResponse );
  }, delayCount)

  // ---------------------
  // Handlers
  // ---------------------

  const onRefresh = async () => {
    let siteResponse = await getSiteList( themeSelected );
    if( siteResponse.status === 'success' )
      setSites( siteResponse );
    
    siteResponse = await getSiteList( themeSelected, {count:true} );
    if( siteResponse.status === 'success' )
      setSites( siteResponse );
  }

  const onChangeTheme = async (e) => {
    const themeSelectedLocal = e.target.value;
    let siteResponse = await getSiteList( themeSelectedLocal );
    if( siteResponse.status === 'success' )
      setSites( siteResponse );
    
    // Update selected theme
    setThemeSelected(themeSelectedLocal);

    // Reset count and trigger count loading
    // setDelayCount(null)
    // setDelayCount(200)

    console.log("siteResponse on theme change ", siteResponse )


    const scrapperImport = scrapperImportList.find( (item) => item.database === themeSelectedLocal )
    console.log("Scrapper Import on change ", scrapperImport )
    let isTriggeringEnabledLocal = false;
    // if(scrapperImport != null)
    //   isTriggeringEnabledLocal = ENABLED_DATABASES.includes(scrapperImport.database) && scrapperImport.status !== 'ongoing';
    if(scrapperImport != null)
      isTriggeringEnabledLocal = scrapperImport.status !== 'ongoing';         
    setIsTriggeringEnabled( isTriggeringEnabledLocal );

    siteResponse = await getSiteList( themeSelectedLocal, {count:true} );
    console.log("Theme selected in timeout ", themeSelected, delayCount )
    if( siteResponse.status === 'success' )
      setSites( siteResponse );

    
  }

  const onTriggerImportTheme = async () => {
    await postScrapperImportTrigger( themeSelected )
    setIsTriggeringEnabled( false );

    const scrapperImportListLocal = JSON.parse( JSON.stringify( scrapperImportList ) );
    const scrapperImport = scrapperImportListLocal.find( (item) => item.database === themeSelected )
    scrapperImport.status = 'ongoing'
    setScrapperImportList( scrapperImportListLocal )

    // Poll peridiocally
    setDelayTrigger(2000)
  }

  // ---------------------
  // Presentational Methods
  // ---------------------
  const scrapperImport = scrapperImportList.find( (item) => item.database === themeSelected )
  const getLastStartedImport = () => {
    if( scrapperImport ){
      return scrapperImport.lastStartedImportDate ?  DateTime.fromISO( scrapperImport.lastStartedImportDate ).toFormat("yyyy-MM-dd HH:mm:ss") : 'N/A'
    }
      
    return 'N/A'
  }

  const getLastCompletedImport = () => {
    if( scrapperImport ){
      return scrapperImport.lastCompletedImportDate ?  DateTime.fromISO( scrapperImport.lastCompletedImportDate ).toFormat("yyyy-MM-dd HH:mm:ss") : 'N/A'
    }
    return 'N/A'
  }

  const getLastStatusImport = () => {
    if( scrapperImport ){
      if( scrapperImport.status === 'ongoing' )
        return <span className={`lnr lnr-sync`} />
      if( scrapperImport.status === 'completed' )
        return <span className={`lnr lnr-checkmark-circle`} />        
      if( scrapperImport.status === 'failed' )
        return <span className={`lnr lnr-cross-circle`} />                        
        
      return scrapperImport.status
    }
    return 'N/A'
  }

  const csvExport = () => {
    const header = "Collection,Scrapped Count, Imported Count\n"
    let csvContent = sites.data.reduce((acc, item) => {
      const scrappedCount = item.scrapped_count != null ? item.scrapped_count : 'N/A';
      const importedCount = item.imported_count != null ? item.imported_count : 'N/A';
      return acc + `${item.name},${scrappedCount},${importedCount}\n`;
    }, header);
    csvContent += `TOTAL,${sites.scrapped_count_total},${sites.import_count_total}\n`
    

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${themeSelected}_import_status.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const isCountAvailable = sites.import_count_total != null;


  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <h5 className='bold-text'>Themes</h5>
            <FormGroup className='mt-2 mb-2 me-sm-2 mb-sm-0'>
              <Row>
                <Col xs={4}>
                  
                  <Input
                    type='select'
                    placeholder='Select the promo code type'
                    onChange={onChangeTheme}
                    value={themeSelected || ''}
                    disabled={isCountAvailable == false}
                  >
                    {themes.map((theme, idx) => (
                      <option key={idx} value={theme.name}>
                        {theme.name}
                      </option>
                    ))}
                  </Input>

                </Col>
                <Col xs={4}>
                  <div className='d-flex flex-column align-items-start justify-content-center h-100'>
                    <table>
                      <tbody>
                        <tr>
                          <td>Last Import Started  </td>
                          <td>{themeSelected && getLastStartedImport()}</td>
                        </tr>
                        <tr>
                          <td className='pr-3'>Last Import Completed</td>
                          <td>{themeSelected && getLastCompletedImport()}</td>
                        </tr>
                        <tr>
                          <td>Last Import Status</td>
                          <td>{themeSelected && getLastStatusImport()}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                
            
                </Col>
                <Col xs={4}>                
                  <Button disabled={!isTriggeringEnabled}
                    color={`primary ${isTriggeringEnabled?'':'text-secondary'}`}
                    size='sm'
                    className='mb-0'
                    onClick={onTriggerImportTheme}>
                    Import Theme
                  </Button>
                </Col>

              </Row>



            </FormGroup>
              
          {sites.data.length === 0 && (
            <h5 className='bold-text mb-2'>No scraped data</h5>
          )}
          <Button
            color='primary'
            size='sm'
            className='mb-0'
            onClick={() => csvExport()}
            disabled={sites.data.length === 0 || sites.data.some(obj => obj.scrapped_count == null)}
          >
            Export to CSV <span className={`lnr lnr-download`} />
          </Button>
          <Button
            color='primary'
            size='sm'
            className='mb-0'
            onClick={() => onRefresh()}
            disabled={sites.data.length === 0 || sites.data.some(obj => obj.scrapped_count == null)}
          >
            Refresh <span className={`lnr lnr-sync`} />
          </Button>
          {sites.data.length > 0 && (
            <Table className='mt-5'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Collection</th>
                  <th>Scrapped Count {isCountAvailable?null:<Spinner  size="sm"/>}</th>
                  <th>Scraper Start {isCountAvailable?null:<Spinner  size="sm"/>}</th>
                  <th>Scraper End {isCountAvailable?null:<Spinner  size="sm"/>}</th>
                  <th>Scraper Duration {isCountAvailable?null:<Spinner  size="sm"/>}</th>
                  <th>Scraped Cars Today {isCountAvailable?null:<Spinner  size="sm"/>}</th>
                  <th>Imported Count {isCountAvailable?null:<Spinner  size="sm"/>}</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {sites.data.map((item, idx) => (
                  <tr key={idx}>
                    <td scope='row'>{idx + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.scrapped_count?.toLocaleString()}</td>
                    <td>{item.scraper_started_at ? DateTime.fromISO( item.scraper_started_at ).toFormat("yyyy-MM-dd HH:mm:ss") : null}</td>
                    <td>{item.scraper_ended_at ? DateTime.fromISO( item.scraper_ended_at ).toFormat("yyyy-MM-dd HH:mm:ss") : null}</td>
                    <td>{item.scraper_started_at && item.scraper_ended_at ? DateTime.fromISO(item.scraper_ended_at).diff(DateTime.fromISO(item.scraper_started_at)).toFormat("hh:mm:ss") : null}</td>
                    <td>{item.scrapped_count?.toLocaleString()}</td>
                    <td>{item.imported_count?.toLocaleString()}</td>
                    {/* <td>
                      <Button
                        color='primary'
                        size='sm'
                        className='mb-0'
                        onClick={() => console.log("importing DB")}
                      >
                        Import Site
                      </Button>
                    </td> */}
                  </tr>
                ))}
                <tr>
                  <td></td>
                  <td className='text-left font-weight-bold'>TOTAL</td>
                  <td className='font-weight-bold'>{sites.scrapped_count_total?.toLocaleString()}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className='font-weight-bold'>{sites.import_count_total?.toLocaleString()}</td>                  
                </tr>
              </tbody>
            </Table>
          )}


        </CardBody>
      </Card>
    </Col>
  );
};

export default PageContent;
